module.exports = __webpack_public_path__ + "img/wdr4-tickets.3d986a7b.svg";